import defaultDayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isBetween from "dayjs/plugin/isBetween";
import relativeTime from "dayjs/plugin/relativeTime";
import weekday from "dayjs/plugin/weekday";
import localizedFormat from "dayjs/plugin/localizedFormat";
import dayjsBusinessDays from "dayjs-business-days";
import weekOfYear from "dayjs/plugin/weekOfYear";
import "dayjs/locale/sq";
import { APP_DEFAULT_TZ, getCompanyTimezone } from "./timezone/teamTimezone";

defaultDayjs.locale("sq");
defaultDayjs.extend(utc);
defaultDayjs.extend(timezone);
defaultDayjs.extend(customParseFormat);
defaultDayjs.extend(duration);
defaultDayjs.extend(relativeTime);
defaultDayjs.extend(isSameOrBefore);
defaultDayjs.extend(isBetween);
defaultDayjs.extend(isSameOrAfter);
defaultDayjs.extend(weekday);
defaultDayjs.extend(weekOfYear);
defaultDayjs.extend(localizedFormat);
defaultDayjs.extend(dayjsBusinessDays);

defaultDayjs.tz.setDefault(APP_DEFAULT_TZ);

/**
 * App-wide dayjs helper — company IANA zone (real DST), never browser local.
 */
const dayjsTZ = (...args) => {
  const zone = getCompanyTimezone();
  if (args.length === 0) {
    return defaultDayjs().tz(zone);
  }
  return defaultDayjs(...args).tz(zone);
};

const timezonedUnix = (value) => {
  return defaultDayjs.unix(value).tz(getCompanyTimezone());
};

dayjsTZ.unix = timezonedUnix;

/**
 * Explicit IANA zone (real DST). Use for per-team timezone wiring.
 * Falls back to APP_DEFAULT_TZ when tz is missing.
 *
 * @param {string|undefined|null} tz
 * @param {...any} args same as dayjs(...)
 */
export function dayjsInTz(tz, ...args) {
  const zone =
    typeof tz === "string" && tz.trim() ? tz.trim() : APP_DEFAULT_TZ;
  if (args.length === 0) {
    return defaultDayjs().tz(zone);
  }
  return defaultDayjs(...args).tz(zone);
}

export function nowInTz(tz) {
  return dayjsInTz(tz);
}

/** Calendar day key YYYY-MM-DD in the given IANA zone. */
export function dayKeyInTz(tz, value) {
  return dayjsInTz(tz, value).format("YYYY-MM-DD");
}

/** 24h clock display. */
export function formatTime24(tz, value) {
  return dayjsInTz(tz, value).format("HH:mm");
}

export { APP_DEFAULT_TZ, getCompanyTimezone };
export default dayjsTZ;
